import PropTypes from 'prop-types';

const MoneyFormatter = ({ number }) =>
  number !== null ? (
    <>
      {new Intl.NumberFormat('pl-PL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number / 100)}
    </>
  ) : (
    <>-</>
  );

MoneyFormatter.propTypes = {
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default MoneyFormatter;
